import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { onApiCall } from '../../../common/store/generic.reducer';
import { GenericState, IState } from '../../../common/store/types';
import { ChequeRemittanceModel } from './types';
import { chequeRemittanceActions } from './cheque-remittance.actions';

export interface IChequeRemittanceState extends IState<ChequeRemittanceModel> {
  getById: GenericState<ChequeRemittanceModel>;
  createInstance: GenericState<ChequeRemittanceModel>;
  add: GenericState<ChequeRemittanceModel>;
  delete: GenericState<boolean>;
  deleteFromList: GenericState<boolean>;
  getChequeRemittancePdf: GenericState<any>;
}

export const chequeRemittanceInitialState: IChequeRemittanceState = {
  getById: new GenericState<ChequeRemittanceModel>(),
  createInstance: new GenericState<ChequeRemittanceModel>(),
  add: new GenericState<ChequeRemittanceModel>(),
  delete: new GenericState<boolean>(),
  deleteFromList: new GenericState<boolean>(),
  getChequeRemittancePdf: new GenericState<any>(),
};

const chequeRemittanceReducers = [
  ...onApiCall<ChequeRemittanceModel>(
    chequeRemittanceActions.getById,
    'getById',
  ),
  ...onApiCall<ChequeRemittanceModel>(
    chequeRemittanceActions.createInstance,
    'createInstance',
  ),
  ...onApiCall<ChequeRemittanceModel>(chequeRemittanceActions.add, 'add'),
  ...onApiCall<boolean>(chequeRemittanceActions.delete, 'delete'),
  ...onApiCall<boolean>(
    chequeRemittanceActions.deleteFromList,
    'deleteFromList',
  ),
  ...onApiCall<any>(
    chequeRemittanceActions.getChequeRemittancePdf,
    'getChequeRemittancePdf',
  ),
];

export const chequeRemittanceReducer = createReducer(
  chequeRemittanceInitialState,
  ...chequeRemittanceReducers,
) as ActionReducer<IChequeRemittanceState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return chequeRemittanceReducer(state, action);
}
